import * as React from "react";
const SvgMinus20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 2,
        fill: "black",
        viewBox: "0 0 12 2"
      },
      props
    ),
    React.createElement("path", {
      fill: "#000",
      fillRule: "evenodd",
      d: "M12 0v2H0V0h12Z",
      clipRule: "evenodd"
    })
  );
export default SvgMinus20Px;
